module.exports = __webpack_public_path__ + "static/media/SMotorE.a8182944.jpeg";